/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_ApprovedInputs */



/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Transcript_Export_Field_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_approved = /** @type {((inputs?: Transcript_Export_Field_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "de") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "es") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Approved")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Approved")
	return /** @type {LocalizedString} */ ("Approved")
});